import { type OnboardingStep } from '../domain/Onboarding'

export function formatStepTitle(pendingSteps: Array<OnboardingStep>, stepName?: OnboardingStep) {
  const totalSteps = pendingSteps.length
  if (!stepName || totalSteps === 1) return ''

  return `Step ${pendingSteps.indexOf(stepName) + 1}/${totalSteps}`
}
